import styled from "styled-components";

// Global CSS styles for customer objections modal
const globalStyles = `
  .customer-objections-modal .ant-modal-content {
    border-radius: 10px !important;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25) !important;
    overflow: hidden !important;
  }

  .customer-objections-modal .ant-modal-header {
    background: linear-gradient(135deg, #cf1322 100%, #ff4d4f 0%);;
    border-bottom: none !important;
    padding: 20px 24px !important;
    border-radius: 10px 10px 0 0 !important;
  }

  .customer-objections-modal .ant-modal-title {
    color: #fff !important;
    font-weight: 600 !important;
    font-size: 18px !important;
    margin: 0 !important;
  }

  .customer-objections-modal .ant-modal-close {
    top: 16px !important;
    right: 16px !important;
  }

  .customer-objections-modal .ant-modal-close-x {
    color: #fff !important;
    font-size: 16px !important;
    width: 32px !important;
    height: 32px !important;
    line-height: 32px !important;
    transition: all 0.3s ease !important;
    border-radius: 50% !important;
  }

  .customer-objections-modal .ant-modal-close-x:hover {
    background-color: rgba(255, 255, 255, 0.2) !important;
  }

  .customer-objections-modal .ant-modal-body {
    padding: 24px !important;
    background: #fff !important;
  }

  .customer-objections-modal .ant-modal-footer {
    border-top: 1px solid #f0f0f0 !important;
    padding: 16px 24px !important;
    background: #fff !important;
    border-radius: 0 0 10px 10px !important;
    text-align: right !important;
  }

  .customer-objections-modal .ant-btn {
    height: 40px !important;
    border-radius: 6px !important;
    font-weight: 500 !important;
    transition: all 0.3s ease !important;
  }

  .customer-objections-modal .ant-btn-primary {
    background: #cf1322 !important;
    border-color: #cf1322!important;
    color: #fff !important;
  }

  .customer-objections-modal .ant-btn-primary:hover:not(:disabled) {
    background: #cf1322 !important;
    border-color: #cf1322 !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 8px rgba(207, 19, 34, 0.3) !important;
  }

  .customer-objections-modal .ant-btn-primary:disabled {
    background: #f5f5f5 !important;
    border-color: #d9d9d9 !important;
    color: #bfbfbf !important;
  }

  .customer-objections-modal .ant-btn-default {
    border-color: #d9d9d9 !important;
    color: #666 !important;
  }

  .customer-objections-modal .ant-btn-default:hover {
    border-color: #cf1322 !important;
    color: #cf1322 !important;
  }
`;

// Inject global styles
if (typeof document !== "undefined") {
    const styleElement = document.createElement("style");
    styleElement.textContent = globalStyles;
    document.head.appendChild(styleElement);
}

export const StyledModal = styled.div`
    .ant-modal {
        max-width: 85%;
    }

    .ant-modal-content {
        border-radius: 10px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
        overflow: hidden;
    }

    .ant-modal-header {
        background: linear-gradient(135deg, #cf1322 100%, #ff4d4f 0%);
        border-bottom: none;
        padding: 20px 24px;
        border-radius: 10px 10px 0 0;

        .ant-modal-title {
            color: #fff;
            font-weight: 600;
            font-size: 18px;
            margin: 0;
        }
    }

    .ant-modal-close {
        top: 16px;
        right: 16px;

        .ant-modal-close-x {
            color: #fff !important;
            font-size: 16px;
            width: 32px;
            height: 32px;
            line-height: 32px;
            transition: all 0.3s ease;
            border-radius: 50%;

            &:hover {
                background-color: rgba(255, 255, 255, 0.2);
            }
        }
    }

    .ant-modal-body {
        padding: 24px;
        background: #fff;
        max-height: 70vh;
        overflow-y: auto;
    }

    .ant-modal-footer {
        border-top: 1px solid #f0f0f0;
        padding: 16px 24px;
        background: #fff;
        border-radius: 0 0 10px 10px;
        text-align: right;

        .ant-btn {
            height: 40px;
            border-radius: 6px;
            font-weight: 500;
            transition: all 0.3s ease;
        }

        .ant-btn-primary {
            background: #cf1322;
            border-color: #cf1322;
            color: #fff;

            &:hover:not(:disabled) {
                background: #cf1322;
                border-color: #cf1322;
                transform: translateY(-1px);
                box-shadow: 0 4px 8px rgba(207, 19, 34, 0.3);
            }

            &:disabled {
                background: #f5f5f5;
                border-color: #d9d9d9;
                color: #bfbfbf;
            }
        }

        .ant-btn-default {
            border-color: #d9d9d9;
            color: #666;

            &:hover {
                border-color: #cf1322;
                color: #cf1322;
            }
        }
    }
`;
